import {inject} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {catchError, map, mergeMap} from "rxjs/operators";
import {of} from "rxjs";
import {InhibitionConnectivityActions} from "./inhibition-connectivity.actions";
import {InhibitionRepo} from "src/app/repositories/inhibition.repo";
import {TableInhibitionMonitoringList} from "src/app/mapper/table/table-inhibition-monitoring-list";
import {CurrentInhibitionInfosList} from "src/swagger-gen/gnvert-secured/models";

export class InhibitionConnectivityEffect {
  private readonly actions$ = inject(Actions);
  private readonly inhibitionRepo = inject(InhibitionRepo);
  private readonly tableInhibitionMonitoringList = inject(TableInhibitionMonitoringList);

  fetchData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InhibitionConnectivityActions.searchAll),
      mergeMap(() => {
        return this.inhibitionRepo
          .getInhibitions({ limit: 10000, offset: 0 }) // Because there will never be more than 10 0000
          .pipe(
            map((response) =>
              // Sort from the least to the most recent
              response.list?.sort((a, b) => new Date(a.datetime).getTime() - new Date(b.datetime).getTime())
            ),
            map((list) =>
              this.tableInhibitionMonitoringList.init(list as CurrentInhibitionInfosList)
            ),
            map((data) => InhibitionConnectivityActions.fetchSuccess({ data })),
            catchError((error) =>
              of(
                InhibitionConnectivityActions.fetchFailure({
                  message: error?.toString(),
                })
              )
            )
          );
      })
    );
  });
}
